import { motion } from 'framer-motion';
import { NEONVERSE } from '../constants';

const NeonPersonalization = () => (
  <section
    className="nv-section"
    id="personalization"
    style={{
      background: 'var(--nv-ink-soft)',
      borderBlock: '1px solid var(--nv-line)',
    }}
  >
    <div className="nv-container">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-80px' }}
        transition={{ duration: 0.55 }}
      >
        <p className="nv-eyebrow">Customization</p>
        <h2 className="nv-title">Personalization Options</h2>
        <p className="nv-lead">
          Every song can be customized to match your vision. Choose your preferred details—your
          imagination is the only limit.
        </p>
        <div className="nv-flow">
          {NEONVERSE.personalization.map((item) => (
            <span key={item}>{item}</span>
          ))}
        </div>
        <p className="nv-note">Your imagination is the only limit.</p>
      </motion.div>
    </div>
  </section>
);

export default NeonPersonalization;
